export default {
  'payoutFeeReport.title': '打款费用报表',

  'payoutFeeReport.column.date': '订单日期',
  'payoutFeeReport.column.type': '类型',
  'payoutFeeReport.column.payout_range': '交易时间',
  'payoutFeeReport.column.payout_date': '打款日期',
  'payoutFeeReport.column.payment_amount': '总交易额',
  'payoutFeeReport.column.others': '其它',
  'payoutFeeReport.column.others.description': '总部礼品卡/会员充值收费和非处理费',
  'payoutFeeReport.column.fees': '扣费',
  'payoutFeeReport.column.refund': '拒付 / 退单金额',
  'payoutFeeReport.column.transaction_fee': '刷卡手续扣费',
  'payoutFeeReport.column.transaction_fee.description': '该扣费只针对于固定费率。',
  'payoutFeeReport.column.amount': '实际打款金额',
  'payoutFeeReport.column.state': '打款状态',
  'payoutFeeReport.column.note': '备注',

  'payoutFeeReport.section.payoutDetail': '打款详情',
  'payoutFeeReport.section.feeDetail': '收费详情',

  'payoutFeeReport.fee.type': '类型',
  'payoutFeeReport.fee.payout_range': '打款区间',
  'payoutFeeReport.fee.chargeDate': '日期',
  'payoutFeeReport.fee.date': '日期',
  'payoutFeeReport.fee.itemName': '收费项目',
  'payoutFeeReport.fee.sumAmount': '总计',
  'payoutFeeReport.fee.tax': '税',
  'payoutFeeReport.fee.amount': '总金额',
  'payoutFeeReport.fee.status': '状态',
  'payoutFeeReport.fee.notes': '备注',
  'payoutFeeReport.fee.summary': '总计',
  'payoutFeeReport.fee.download_link': '下载',
};
